import axios from "axios";

const createShipment = async (
  customerAddress: Record<string, any>,
  orderItems: Record<string, any>[],
  companyId: string
) => {
  console.log({ companyId });
  // Configure the Axios request
  const config = {
    method: "post",
    url: `/api/service/shipping/shipment/create`,
    headers: {
      "Content-Type": "application/json",
    },
    data: {
      addressTo: {
        name: customerAddress.firstName + " " + customerAddress.lastName,
        street1: customerAddress.address1,
        street2: customerAddress.address2,
        city: customerAddress.city,
        state: customerAddress.state,
        zip: customerAddress.zipcode,
        country: customerAddress.country,
        phone: customerAddress.phoneNumber,
        email: customerAddress.email,
        is_residential: true,
      },
      orderItems,
      companyId,
    },
    maxRedirects: 5,
  };

  // Make the request
  return await axios(config)
    .then((response) => {
      console.log({ response });
      return response.data;
    })
    .catch((error) => {
      console.error(`Error getting shipping info`, error); // Handle errors
      return {
        error: true,
        message: "Error creating shipment",
      };
    });
};

export { createShipment };
